import { PoundBoxOutlineIcon } from './PoundBoxOutlineIcon';

/**
 * author: Michael Richins
 * id BC212E3B-C9D9-4FC5-B73B-DDA77D94A5C9
 * name pound-box-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pound-box-outline.svg
 * tags
 */
export const HashtagBoxOutlineIcon = PoundBoxOutlineIcon;
export default HashtagBoxOutlineIcon